import React, { Component } from "react";
import { Link } from 'react-router-dom'
import MQSGUtil from "../mqsgUtil";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Timeline from "highcharts/modules/timeline.js"
import Nodata from "highcharts/modules/no-data-to-display";
import moment from "moment"
import "./DataModal.css";
Nodata(Highcharts);
Timeline(Highcharts);
export default class DataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalData: [
                {
                    id: 1,
                    headText: "Hong Kong stock warrants",
                    profileImg: "/img/education/sflag_hk.svg",
                    text: "Warrants tracking Hong Kong stocks listed on the Hong Kong Stock Exchange, trade in Singapore dollars on the SGX. The list of Hong Kong stocks available as of 20 October 2026 include,",
                    text1:'1) Alibaba<br/>2) China Life<br/>3) Meituan<br/>4) PetroChina<br/>5) Tencent<br/>6) SMIC<br/>7) Xiaomi<br/>8) ChinaA50 ETF<br/>',
                    text2:'<br/>The market-making hours of Hong Kong stock warrants are from 930AM to 12PM; 1PM to 5PM, with Macquarie pulling quotes 2 minutes from the closing hours. There will be no market-making in the Hong Kong stock warrants when the Hong Kong market is shut.<br/>'
                    // text2:'<br/>*Available over well-known Hong Kong shares.  *Subject to changes<br/>*Trading hours of Hong Kong’s shares overlap with Singapore’s trading hours<br/>* Provides the ability to hedge against Hong Kong shareholding positions<br/><br/>The market-making hours of Hong Kong stock warrants are from 930AM to 12PM; 1PM to 5PM, with Macquarie pulling quotes 2 minutes from the closing hours. There will be no market-making in the Hong Kong stock warrants when the Hong Kong market is shut.<br/>'
                },
                {
                    id: 2,
                    headText: "Singapore stock warrants",
                    profileImg: "/img/education/singapore_flag_svg.png",
                    text: `Macquarie’s stock warrants track well-known Singapore stock names generally priced above $1 as of 20 October 2026. They include,`,
                    text1:'1) City Developments<br/>2) DBS<br/>3) iFast<br/>4) Jardine Matheson<br/>5) Keppel<br/>6) OCBC<br/>7) SATS<br/>8) Seatrium<br/>9) Sembcorp Industries<br/>10) Singapore Airlines<br/>11) Singapore Exchange<br/>12) SingTel<br/>13) ST Engineering<br/>14) UOB<br/>15) Wilmar<br/>16) Yangzijiang Shipbuilding (Singapore)<br/>17) Amova Singapore STI Index ETF<br/>18) SPDR® Gold Shares ETF<br/>',
                    text2:'<br/>The market-making hours of Singapore stock warrants follow that of the Singapore securities i.e. from 9AM to 12PM; 1PM to 5PM, with Macquarie pulling quotes 2 minutes from the closing hours.'
                    // text2:'*Warrants available over a range of large-cap and mid-cap names. *Subject to changes<br/>*Trade at a fraction of underlying share prices<br/>* Provides the ability to hedge against shareholding positions<br/><br/>The market-making hours of Singapore stock warrants follow that of the Singapore securities i.e. from 9AM to 12PM; 1PM to 5PM, with Macquarie pulling quotes 2 minutes from the closing hours.'
                }
            ],
            showModaData: {},
            ranking: [],
        }
    }
    
    componentDidMount() {
        this.setState({
            showModaData: this.state.modalData[this.props.keyValue - 1]
        })
        this.getWarrantData(this.props.keyValue)

    }
    getWarrantData(keyValue) {
        const qid = Date.now()
        let name = '';
        if(keyValue === 1){
            name = 'hk_stock'
        }else{
            name = 'sg_stock'
        }
        const url =
            MQSGUtil.getAPIBasePath() + `/MarketDataJSON?type=${name}&lmt=all&qid=` + qid;
        fetch(url)
            .then((res) => res.json())
            .then(
                (result) => {
                    this.setState({
                        ranking: result.ranking
                    })
                },
                (error) => {

                }
            );
    }
    setOpen() {
        this.props.setValue(false)
    }
    render() {
        return (
            <div id="ppBoxHTML1" className="overlay indexModal" style={{ display: this.props.show ? 'block' : 'none' }}>
                <div className="overlay-inner" style={{ background: '#F5F6F7', width: '85%' }}>
                    <div style={{ position: 'relative' }}>
                        <img
                            className="btn-close"
                            style={{}}
                            src="/img/education/icon-close-black.png"
                            onClick={() => this.setOpen(false)}
                        />
                        <div className="popupbox-content" style={{ paddingLeft: '15px', paddingRight: '15px' }}><div className="ppc" key="What-is-NDX">
                            <div className="row">
                                <div className="col-sm-12" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <img
                                        src={this.state.showModaData?.profileImg}
                                        style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                    <h2 className="ppc-h">{this.state.showModaData?.headText}</h2><h2>
                                    </h2></div>
                                <div className="col-sm-12" style={{ marginTop: '10px' }}>
                                    <p dangerouslySetInnerHTML={{ __html: this.state.showModaData !== undefined ? this.state.showModaData.text : "", }}>
                                    </p>
                                    <p dangerouslySetInnerHTML={{ __html: this.state.showModaData !== undefined ? this.state.showModaData.text1 : "", }}>
                                    </p>
                                    {this.state.showModaData.id === 1 ?<div className="stockWarrantsThreeBox">
                                            <div>
                                                <img
                                                    src="/img/education/hkAvailable.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Available over well-known Hong Kong shares.</p>
                                                <p>*Subject to changes</p>
                                            </div>
                                            <div>
                                                <img
                                                    src="/img/education/hkTrading.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Trading hours of Hong Kong’s shares overlap</p>
                                                <p>with Singapore’s trading hours</p>
                                            </div>
                                            <div>
                                                <img
                                                    src="/img/education/hkProvides.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Provides the ability to hedge</p>
                                                <p>against Hong Kong shareholding positions</p>
                                            </div>
                                        </div>:<div className="stockWarrantsThreeBox">
                                            <div>
                                                <img
                                                    src="/img/education/sgpWarrants.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Warrants available over a range of large-cap and mid-cap names.</p>
                                                <p>*Subject to changes</p>
                                            </div>
                                            <div>
                                                <img
                                                    src="/img/education/sgpTrade.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Trade at a fraction</p>
                                                <p>of underlying share prices</p>
                                            </div>
                                            <div>
                                                <img
                                                    src="/img/education/sgpProvides.png"
                                                    style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                                <p>Provides the ability to hedge</p>
                                                <p>against shareholding positions</p>
                                            </div>
                                        </div>
                                    }
                                    <p dangerouslySetInnerHTML={{ __html: this.state.showModaData !== undefined ? this.state.showModaData.text2 : "", }}>
                                    </p>
                                </div>
                                <div className="col-sm-12" style={{ clear: 'both' }}>
                                    <h2 className='table-heading'>{this.state.showModaData?.headText}</h2>
                                    <table id="warranttbl" className="table table-striped table-closed table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Warrant Name</th>
                                                {/* <th>Underlying</th> */}
                                                <th>Type</th>
                                                <th className="hidden-xs">Last bid price</th>
                                                <th className="hidden-xs">Change</th>
                                                <th className="hidden-xs">Change (%)</th>
                                                <th className="hidden-xs">Volume ('000)</th>
                                                <th>Expiry</th>
                                                <th className="hidden-xs">Last trading date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ranking && this.state.ranking.map((d) =>
                                                <tr className="rowtmpl" idx={0}>
                                                    <td className="col_dsply_nmll"><a target="_blank" href={`/tools/livematrix/${d.ticker}`}>{d.dsply_nmll}</a></td>
                                                    {/* <td className="col_underlying_ticker"><a target="_blank" href={`/my/tools/underlying/${d.underlying_ric}`}>{d.underlying_ticker}</a></td> */}
                                                    <td className="col_type">{d.type === 'PUT' ? "P" : 'C'}</td>
                                                    <td className="hidden-xs col_BID">{MQSGUtil.formatNumberDisplay(d.BID, 3)}</td>
                                                    <td className={d.BID_NETCHNG.includes("-") ? "hidden-xs col_BID_NETCHNG down" : "hidden-xs col_BID_NETCHNG up"}>{MQSGUtil.formatNumberDisplay(d.BID_NETCHNG, 2)}</td>
                                                    <td className={d.BID_PCTCHNG.includes("-") ? "hidden-xs col_BID_PCTCHNG down" : "hidden-xs col_BID_PCTCHNG up"}>{MQSGUtil.formatNumberDisplay(d.BID_PCTCHNG, 2)}</td>
                                                    <td className="hidden-xs col_ACVOL_1_SCALED">{MQSGUtil.formatNumberDisplay(d.ACVOL_1_SCALED)}</td>
                                                    <td className="col_maturity">{d.maturity}</td>
                                                    <td className="hidden-xs col_last_trading_date">{d.last_trading_date}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <p className="underlying_note">
                                        Last updated: {new Date().toLocaleString('en-GB', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                            }).replace(',', '') }
                                    </p>
                                    <p className="underlying_note">
                                        All market data is delayed 15 mins unless otherwise indicated by timestamp.
                                    </p>
                                </div>
                            </div>
                        </div></div>
                    </div>
                </div>
            </div>
        )
    }

}